import { DeviceKey, IfKey, KeyNames, KeyPair, Key } from "../Core/Keys";
import { DeviceCategory } from "../Core/DeviceCategory";
import { List } from "../Utils/List";
import { Dictionary } from "../Utils/Dictionary";

export class TopoImageKeyNames {
	public static DeviceCategory = "dvcat";
	public static Vendor = "vnd";
	public static Status = "status";
}

//export interface TopoImageKeyJson extends KeyJson {
//}

export class TopoImageKey extends Key {

	public AddEmptyCat(): void {
		this.Add(new KeyPair(TopoImageKeyNames.DeviceCategory, ""));
	}

	public get Category(): DeviceCategory {
		var cat: KeyPair = this.Find(TopoImageKeyNames.DeviceCategory);
		if (cat != null)
			return DeviceCategory.Get(cat.Value);
		else
			return DeviceCategory.Get("");
	}
	public set Category(value: DeviceCategory) {
		var cat: KeyPair = this.Find(TopoImageKeyNames.DeviceCategory);
		if (cat != null)
			cat.Value = value.Name;
		else
			this.Add(new KeyPair(TopoImageKeyNames.DeviceCategory, value.Name));
	}

	public get Vendor(): string {
		var vend: KeyPair = this.Find(TopoImageKeyNames.Vendor);
		if (vend != null)
			return vend.Value;
		else
			return null;
	}
	public set Vendor(value: string) {
		var vend: KeyPair = this.Find(TopoImageKeyNames.Vendor);
		if (vend != null)
			vend.Value = value;
		else
			this.Add(new KeyPair(TopoImageKeyNames.Vendor, value));
	}

	public get Status(): string {
		var status: KeyPair = this.Find(TopoImageKeyNames.Status);
		if (status != null)
			return status.Value;
		else
			return null;
	}
	public set Status(value: string) {
		var status: KeyPair = this.Find(TopoImageKeyNames.Status);
		if (status != null)
			status.Value = value;
		else
			this.Add(new KeyPair(TopoImageKeyNames.Status, value));
	}

    //public static FromJson(json: TopoImageKeyJson): TopoImageKey {
    //    var result = new TopoImageKey();

    //    result.CopyKeyJson(json);

    //    return result;
    //}

	public Write(obj: any, objSerName: string, context: any): void {
		super._Write(obj, objSerName, context);
	}

	public Read(obj: any, objSerName: string, context: any): void {
		super._Read(obj, objSerName, context);
	}
}

export class TopoImageEntry {
	public Key: TopoImageKey;
	public get HasKey(): boolean {
		return !!this.Key;
	}
	public Image: HTMLImageElement;
	public get HasImage(): boolean {
		return !!this.Image;
	}

	constructor() {
		this.Key = new TopoImageKey();
	}
}

export class TopoImageMap {
	private _topoImages: Dictionary<TopoImageKey, TopoImageEntry>;
		
	constructor() {
		this._topoImages = new Dictionary<TopoImageKey, TopoImageEntry>();
	}

	public ToList(): List<TopoImageEntry>{
		return this._topoImages.Values();
	}

	public FindEntry(key: TopoImageKey): TopoImageEntry {
		return this._topoImages.Item(key);
	}

	public AddEntries(entries: List<TopoImageEntry>): void {
		entries.ForEach((entry) => {
			this.AddEntry(entry);
		});
	}

	public AddEntry(entry: TopoImageEntry): void {
		if (entry) {
			this._topoImages.Add(entry.Key, entry);
		}
	}

	public RemoveEntry(entry: TopoImageEntry): boolean {
		return this._topoImages.Remove(entry.Key);
	}

	public ContainsEntry(key: TopoImageKey) {
		return this._topoImages.ContainsKey(key);
	}

	public Clear(): void {
		this._topoImages.Clear();
	}
}
